<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
          <v-toolbar dark color="primary">
            <v-col cols="6" class="text-left">
              <v-toolbar-title class="textwithbackground--text">
                {{ title }}
              </v-toolbar-title>
            </v-col>
          </v-toolbar>
          <general-error v-if="!!generalError && !editProxyDialog.show" />
          <v-row class="px-2 pt-2">
            <v-col>
              <v-expansion-panels>
                <v-expansion-panel v-test="{ panel: '' }">
                  <v-expansion-panel-header>
                    <div id="search">
                      <v-icon>
                        search
                      </v-icon>
                      {{ $t('Фильтры') }}
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content eager @keydown.native.enter="focusOnBtn('searchBtn')">
                    <v-row>
                      <v-col
                          class="pl-2"
                          cols="12"
                          sm="10"
                          md="5"
                          lg="3">
                        <validatable-enum-combobox
                            v-model="params.status"
                            v-test="{ combobox: 'status' }"
                            clearable
                            :values-enum="STATUS_ENUM"
                            :label="$t('Статус доверенности')"
                            @change="focusOnBtn('searchBtn')" />
                      </v-col>
                      <v-col
                          class="pl-2"
                          cols="12"
                          sm="10"
                          md="5"
                          lg="3">
                        <v-text-field
                            v-model="params.userName"
                            v-test="{ input: 'userName' }"
                            clearable
                            :label="$t('Наименование пользователя')"
                            single-line
                            hide-details
                            @keydown.native.enter="focusOnBtn('searchBtn')" />
                      </v-col>
                      <v-col
                          class="pl-2"
                          cols="12"
                          sm="10"
                          md="5"
                          lg="3">
                        <v-text-field
                            v-model="params.contactPerson"
                            v-test="{ input: 'contactPerson' }"
                            clearable
                            :label="$t('Контактное лицо')"
                            single-line
                            hide-details
                            @keydown.native.enter="focusOnBtn('searchBtn')" />
                      </v-col>
                      <v-col
                          class="pl-2"
                          cols="12"
                          sm="10"
                          md="5"
                          lg="3">
                        <custom-date-picker
                            v-model="params.dateEnd"
                            v-test="{ date: 'dateEnd' }"
                            :label="$t('Дата завершения действия')"
                            @change="focusOnBtn('searchBtn')" />
                      </v-col>
                      <v-col class="text-right" align-self="center">
                        <btn-icon-tip
                            id="search"
                            ref="searchBtn"
                            icon="search"
                            icon-color="info"
                            :tip="$t('Поиск')"
                            @click="search" />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
          <v-row class="px-2">
            <v-col>
              <paginated-data-table
                  v-if="getProxiesListAdmin"
                  ref="paginatedTable"
                  :headers="headers1"
                  :items="proxies"
                  :loading="isLoading"
                  item-key="proxyId"
                  :total-count="totalCount"
                  :items-per-page="itemsPerPage"
                  single-expand
                  show-expand
                  :request-method="getProxiesListAdmin">

                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <!-- <template v-slot:item.number="{ item }">
                  {{ item.number }}
                </template> -->

                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.contactPerson="{ item }">
                  <route-link-with-tip
                      :id="`${item.userName}-${item.proxyId}`"
                      :text="`${item.userName} (${item.contactPerson})`"
                      :tip="$t('Просмотр пользователя')"
                      :to="{ path: `${urlRootPath}/user/${item.userId}` }" />
                </template>

                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.organizationName="{ item }">
                  <route-link-with-tip
                      :text="item.organizationName"
                      :tip="$t('Просмотр организации')"
                      :to="{ path: `${urlRootPath}/organization/${item.organizationId}` }" />
                </template>

                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.dateBegin="{ item }">
                  {{ item.dateBegin
                    ? $moment(item.dateBegin).format('DD.MM.YYYY')
                    : null }}
                </template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.dateEnd="{ item }">
                  {{ item.dateEnd
                    ? $moment(item.dateEnd).format('DD.MM.YYYY')
                    : null }}
                </template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.processDate="{ item }">
                  {{ item.processDate
                    ? $moment(item.processDate).format('DD.MM.YYYY HH:mm')
                    : null }}
                </template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.notValidDate="{ item }">
                  <icon-tip
                      :id="`notValidDate-${item.proxyId}`"
                      :icon="item.notValidDate
                        ? 'error_outline'
                        : 'check_circle_outline'"
                      :icon-color="item.notValidDate
                        ? 'error'
                        : 'success'"
                      :tip="$t('Документ {0} по датам.', [ $t(item.notValidDate
                        ? 'недействителен'
                        : 'действителен') ])" />
                </template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.status="{ item }">
                  <btn-icon-tip
                      v-if="isAdmin"
                      :id="`editStatus-${item.status}-${item.proxyId}`"
                      icon="fiber_manual_record"
                      :icon-color="item.status === DOCUMENT_STATUSES.INPROCESS
                        ? 'info'
                        : (item.status === DOCUMENT_STATUSES.APPROVED)
                          ? 'success'
                          : 'error'"
                      :tip="$t('Изменить статус. Текущий: {0}', [ $t(STATUS_ENUM[item.status]) ])"
                      @click="openStatusDialog(item.proxyId, item.status)" />
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <v-row class="text-left">
                      <btn-icon-tip
                          :id="`getFile-${item.proxyId}`"
                          :tip="$t('Скачать документ')+': '+item.file.fileName"
                          icon="get_app"
                          @click="getIdentityFile(item.file.fileId)" />
                      <btn-icon-tip
                          :id="`editProxy-${item.proxyId}`"
                          :icon="'edit'"
                          :tip="$t('Редактировать доверенность')"
                          @click="openEditProxyDialog(item.proxyId)" />
                    </v-row>
                  </td>
                </template>
              </paginated-data-table>
            </v-col>
          </v-row>
          <confirm-dialog
              v-if="statusDialog.show"
              :dialog-prop="statusDialog"
              @close="closeDialog('statusDialog')">
            <template v-slot:additional>
              <ValidationObserver ref="status">
                <validatable-enum-combobox
                    v-model="statusDialog.status"
                    v-test="{ combobox: 'proxyStatus' }"
                    rules="required"
                    :values-enum="STATUS_ENUM"
                    :label="$t('Статус доверенности')" />
              </ValidationObserver>
            </template>
          </confirm-dialog>
          <edit-proxy-dialog
              v-if="editProxyDialog.show"
              :dialog-prop="editProxyDialog"
              @close="closeDialog('editProxyDialog')" />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import IconTip from '@/components/reused/ui/IconTip.vue'
  import ValidatableEnumCombobox from '@/components/reused/ui/ValidatableEnumCombobox.vue'
  import RouteLinkWithTip from '@/components/reused/ui/RouteLinkWithTip.vue'
  import PaginatedDataTable from '@/components/reused/ui/PaginatedDataTable.vue'
  import CustomDatePicker from '@/components/reused/ui/CustomDatePicker.vue'
  import ConfirmDialog from '@/components/reused/common/ConfirmDialog.vue'
  import EditProxyDialog from '@/components/reused/proxies/EditProxyDialog.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import getFileMixin from '@/utils/mixins/scoped/getFileMixin.js'
  import { STATUS_ENUM } from '@/constants/enums'
  import { DOCUMENT_STATUSES } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { PROXIES_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      BtnIconTip,
      IconTip,
      RouteLinkWithTip,
      ValidatableEnumCombobox,
      PaginatedDataTable,
      CustomDatePicker,
      ConfirmDialog,
      EditProxyDialog,
      GeneralError
    },
    mixins: [
      getFileMixin('isLoading')
    ],
    props: {
      proxyType: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        DOCUMENT_STATUSES,
        STATUS_ENUM,
        isLoading: false,
        itemsPerPage: 10,
        params: {
          dateEnd: '',
          status: '',
          userName: '',
          contactPerson: ''
        },
        editProxyDialog: {
          show: false,
          proxyId: null,
          callback: null
        },
        statusDialog: {
          show: false,
          status: null,
          proxyId: null,
          callback: null
        },
        itemFirst: () => '',
        itemSecond: () => ''
      }
    },
    computed: {
      ...mapState(PROXIES_MANAGEMENT.NAMESPACE, {
        proxiesInfo: state => proxyType => (state[PROXIES_MANAGEMENT.STATE.PROXIES][proxyType] || {})
      }),
      totalCount () {
        return this.proxiesInfo(this.proxyType).totalCount || 0
      },
      proxies () {
        return this.proxiesInfo(this.proxyType).items || []
      },
      headers1 () {
        const headers = [/* { text: this.$t('Номер доверенности'), sortable: false, value: 'number' }, */
          { text: this.$t('Доверенное лицо'), sortable: false, value: 'contactPerson' },
          { text: this.$t('Организация'), sortable: false, value: 'organizationName' },
          { text: this.$t('Дата начала действия'), sortable: false, value: 'dateBegin' },
          { text: this.$t('Дата завершения действия'), sortable: false, value: 'dateEnd' },
          { text: this.$t('Дата изменения статуса'), sortable: false, value: 'processDate' },
          { text: this.$t('Действительность'), sortable: false, value: 'notValidDate' },
          { text: this.$t('Статус'), sortable: false, value: 'status' },
          { text: '', value: 'data-table-expand' }]

        return headers
      },
      title () {
        return this.$t('Доверенности УП организаций')
      }
    },
    created () {
      this.clearStore()
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(PROXIES_MANAGEMENT.NAMESPACE, {
        getProxiesListAdminAction: PROXIES_MANAGEMENT.ACTIONS.GET_PROXIES_LIST_ADMIN,
        changeProxyStatusAction: PROXIES_MANAGEMENT.ACTIONS.CHANGE_PROXY_STATUS,
        clearProxiesListAdminAction: PROXIES_MANAGEMENT.ACTIONS.CLEAR_PROXIES_LIST_ADMIN
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearProxiesListAdminAction(this.proxyType)
          ])
      },
      search: async function () {
        await this.$refs.paginatedTable.resetPaginationAndGetDataFromServer()
      },
      getProxiesListAdmin: async function (params) {
        try {
          this.isLoading = true
          const model = {
            proxyType: this.proxyType,
            params: {
              ...params,
              ...this.params
            }
          }
          await this.getProxiesListAdminAction(model)
        } catch (error) {
          this.throwIfNotServerError(error)
        } finally {
          this.isLoading = false
        }
      },
      changeProxyStatus: async function () {
        try {
          this.isLoading = true
          await this.changeProxyStatusAction({
            proxyType: this.proxyType,
            status: this.statusDialog.status,
            proxyId: this.statusDialog.proxyId
          })
          await this.$refs.paginatedTable.getDataFromServer()
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      openStatusDialog: function (proxyId, status) {
        this.statusDialog.proxyId = proxyId
        this.statusDialog.status = status
        this.statusDialog.callback = this.changeProxyStatus
        this.statusDialog.show = true
      },
      openEditProxyDialog: function (proxyId) {
        this.editProxyDialog.proxyId = proxyId
        this.editProxyDialog.proxyType = this.proxyType
        this.editProxyDialog.callback = this.$refs.paginatedTable.getDataFromServer
        this.editProxyDialog.show = true
      }
    }
  }
</script>
